/*
 * L.TileLayer.Zoomify display Zoomify tiles with Leaflet
 *
 * Based on the Leaflet.Zoomify (https://github.com/turban/Leaflet.Zoomify)
 * from turban (https://github.com/turban)
 *
 */
import * as L from 'leaflet'

let tileCache = {}

function initZoomify (url, options) {
  let Zoomify = L.TileLayer.extend({
    options: {
      tolerance: 0.8
    },

    initialize: function (url, options) {
      options = L.setOptions(this, options)

      const imageSize = L.point(options.width, options.height)
      // let tileSize = options.tileSize;

      this._imageSize = [imageSize]
      this._gridSize = [this._getGridSize(imageSize)]
      this._url = url

      let dimensions = [imageSize.x, imageSize.y]
      let gridSize = [dimensions[0] / 256, dimensions[1] / 256]

      while (dimensions[0] / 2 >= 384 && dimensions[1] / 2 >= 384) {
        dimensions = [dimensions[0] / 2, dimensions[1] / 2]
        gridSize = [Math.ceil(dimensions[0] / 256), Math.ceil(dimensions[1] / 256)]

        this._imageSize.unshift(L.point(dimensions[0], dimensions[1]))
        this._gridSize.unshift({ x: gridSize[0], y: gridSize[1] })
      }

      this.options.maxZoom = this._gridSize.length - 1
    },

    onAdd: function (map) {
      L.TileLayer.prototype.onAdd.call(this, map)

      // const mapSize = map.getSize()
      // const zoom = this._getBestFitZoom(mapSize)
      // const imageSize = this._imageSize[zoom]
      // const center = map.options.crs.pointToLatLng(L.point(imageSize.x / 2, imageSize.y / 2), zoom)

      // map.setView(center, map.options.initZoom, true)
    },

    _getGridSize: function (imageSize) {
      const tileSize = this.options.tileSize

      return L.point(Math.ceil(imageSize.x / tileSize), Math.ceil(imageSize.y / tileSize))
    },

    _getBestFitZoom: function (mapSize) {
      const tolerance = this.options.tolerance

      let zoom = this._imageSize.length - 1

      while (zoom) {
        let imageSize = this._imageSize[zoom]

        if (imageSize.x * tolerance < mapSize.x && imageSize.y * tolerance < mapSize.y) {
          return zoom
        }

        zoom--
      }

      return zoom
    },

    _addTile: function (tilePoint, container) {
      // Load the tile via the original leaflet code
      L.TileLayer.prototype._addTile.call(this, tilePoint, container)

      // Get out imagesize in pixels for this zoom level and our grid size
      const imageSize = this._imageSize[this._getZoomForUrl()]
      const gridSize = this._gridSize[this._getZoomForUrl()]

      // Get the current tile to adjust
      const key = this._tileCoordsToKey(tilePoint)
      const tile = this._tiles[key].el

      if (tilePoint.x === gridSize.x - 1) {
        tile.style.width = imageSize.x - (self.tileSize * (gridSize.x - 1)) + 'px'
      }

      if (tilePoint.y === gridSize.y - 1) {
        tile.style.height = imageSize.y - (self.tileSize * (gridSize.y - 1)) + 'px'
      }
    },

    createTile: function (coords, done) {
      var tile = document.createElement('img')

      L.DomEvent.on(tile, 'load', L.Util.bind(this._tileOnLoad, this, done, tile))
      L.DomEvent.on(tile, 'error', L.Util.bind(this._tileOnError, this, done, tile))

      if (this.options.crossOrigin || this.options.crossOrigin === '') {
        tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin
      }

      tile.alt = ''
      tile.setAttribute('role', 'presentation')
      tile.src = this.getTileUrl(coords)

      return tile
    },

    getTileUrl: function (tilePoint) {
      const key = `${this._getZoomForUrl()}_${tilePoint.y}_${tilePoint.x}`

      return tileCache[this._url][key]
    },

    getDimensions: function () {
      return { imageSizes: this._imageSize, gridSizes: this._gridSize }
    }
  })

  return new Zoomify(url, options)
}

async function initTiles (fileId, baseUrl='') {
  const response = await fetch(`${baseUrl}/file/tile-map/${fileId}`)

  if (response.ok) {
    const data = await response.json()
    tileCache[`/file/tile/${fileId}`] = data.map
  } else {
    tileCache[`/file/tile/${fileId}`] = {}
  }
}

export {
  initTiles,
  initZoomify
}
